/*
 * CAQ Viewport Tracker
 *
 * Fires window.wmdPageLink('ar-caq_impview') once per CAQ module when the module
 * becomes at least 50% visible in the viewport. Tracking is per-element, so several
 * CAQ modules on one page (A2A feed) are tracked independently.
 */

var IMPVIEW_EVENT = 'ar-caq_impview';

var _observer = null;
var _fired = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

function isVisible(el) {
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
}

function fireTag(el) {
    if (!_fired || _fired.has(el)) {
        return;
    }
    _fired.add(el);

    if (typeof window.wmdPageLink === 'function') {
        window.wmdPageLink(IMPVIEW_EVENT);
    }

    if (_observer) {
        _observer.unobserve(el);
    }
}

function ensureObserver() {
    if (_observer || typeof IntersectionObserver === 'undefined') {
        return _observer;
    }
    // rootMargin '-50% 0px -50% 0px' positions a virtual trigger line at 50% of
    // the viewport height; the observer fires when the element enters that zone.
    _observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            // Fire once the CAQ module is at least 50% visible in the viewport.
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && isVisible(entry.target)) {
                fireTag(entry.target);
            }
        });
    }, {
        root: null,
        threshold: 0.5
    });
    return _observer;
}

/**
 * Start observing a CAQ module element for 50% viewport visibility.
 * @param {Element} el - the .caq-wrapper element to track
 */
function observe(el) {
    if (!el) {
        return;
    }
    var observer = ensureObserver();
    if (!observer) {
        return;
    }
    observer.observe(el);
}

function destroy() {
    if (_observer) {
        _observer.disconnect();
        _observer = null;
    }
    _fired = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
}

module.exports = {
    observe: observe,
    destroy: destroy
};